import { FC } from "react";
import { WarrantyItemForDamaged } from "../../../types";
import SkeletonList from "../../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";
import { DialogContainer } from "./DamagedAndBrokenParts.style";
import DamagedAndBrokenPartsReason from "./DamagedAndBrokenPartsDefect";
import WarrantyBasketItemsHeader from "../WarrantyBasketItemsHeader";
import WarrantyBasketItems from "../WarrantyBasketItems";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

type TDamagedAndBrokenParts = {
    loading: boolean;
    items: WarrantyItemForDamaged[];
    errorList: { key: string; indexes: string[] }[];
};

const DamagedAndBrokenParts: FC<TDamagedAndBrokenParts> = (props) => {
    const { items, loading, errorList } = props;
    const { t } = useTranslation();

    return (
        <DialogContainer>
            {loading ? (
                <SkeletonList
                    mkey="DamagedAndBrokenParts"
                    cols={6}
                    rowsForCell={2}
                    hasHeader
                />
            ) : (
                <>
                    <WarrantyBasketItemsHeader />
                    {items.map((item: WarrantyItemForDamaged, idx: number) => (
                        <WarrantyBasketItems
                            item={item}
                            key={`${idx}_${item.code}_${item.navContext}`} readOnly={false}                        >
                            <DamagedAndBrokenPartsReason
                                item={item}
                                errorList={errorList}
                            />
                        </WarrantyBasketItems>
                    ))}
                </>
            )}
        </DialogContainer>
    );
};

export default DamagedAndBrokenParts;
